export const esteeLauder = () => {
    return(
        <div>
            Как и других компаний сетевого маркетинга, у Estee Lauder была проблема, связанная с выгрузкой большого числа электронных счетов-фактур. Разработать модуль для системы, в которой работает компания, крайне дорого и долго. Мы взяли обычную бухгалтерию, интегрировали с их учетной системой, по сути связали базой SQL. Забираются только данные по реализациям и выгружаются на портал. Также мы автоматизировали здесь процесс создания электронных накладных — СНТ.
        </div>
    )
}